import * as React from 'react';

import { EFacilityType, JsonQuery, NonEmptyArray } from '../../../../../JsonQuery';
import { Facilities } from '../../../components/advancedFilters/Facilities';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const FacilitiesContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const facilityTypes = new JsonQuery(jsonQuery).getFacilityTypes();

  const handleFacilityTypesChange = React.useCallback(
    (facilityTypes: NonEmptyArray<EFacilityType> | null) => {
      onChange({ action: 'setFacilityTypes', arguments: [facilityTypes] });
    },
    [onChange],
  );

  return <Facilities value={facilityTypes} onChange={handleFacilityTypesChange} />;
};
